export default function member({next, store}) {
    let user = store.getters.getUser;
    if (!user || !['member', 'aspirant', 'admin-aspirant', 'admin', 'root'].includes(user.role)) {
        store.dispatch('logout_user');
        return next('/login');
    }
    return next();
}
